import styled from 'styled-components';

export const RecordFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  width: 100%;

  .record__key {
    width: 50%;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
    color: rgba(0, 0, 0, 0.45);
  }

  .record__value {
    width: 50%;
    font-size: 14px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const RecordsGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 18px;
`;
